import { Button } from './Button';

type Props = {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  tone?: 'danger' | 'accent';
  onConfirm: () => void;
  onCancel: () => void;
};

export function ConfirmDialog({ open, title, message, confirmLabel = 'Confirm', tone = 'danger', onConfirm, onCancel }: Props) {
  if (!open) return null;
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2000,
      }}
      onClick={onCancel}
    >
      <div className="card" style={{ width: 380 }} onClick={(e) => e.stopPropagation()}>
        <h3 style={{ marginBottom: 12 }}>{title}</h3>
        <p className="muted" style={{ marginBottom: 20 }}>
          {message}
        </p>
        <div className="row" style={{ justifyContent: 'flex-end' }}>
          <Button tone="neutral" onClick={onCancel} style={{ flex: 'initial' }}>
            Cancel
          </Button>
          <Button tone={tone} onClick={onConfirm} style={{ flex: 'initial' }}>
            {confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}
